import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { seoMeta, canonicalLink } from "@/lib/content-defaults";
import { Route as rootRoute } from "./__root";

// El contenido real vive en plan-online-page.tsx y se descarga aparte (code-split), igual que /clases.
export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/plan-online",
  head: () => ({
    meta: seoMeta({
      title: "Plan online de calistenia — Calistenia Progresiva",
      description: "Plan online personalizado de calistenia: planificación individual, revisión semanal con ajuste y una clase presencial al mes sujeta a disponibilidad.",
      path: "/plan-online",
    }),
    links: [canonicalLink("/plan-online")],
  }),
  component: lazyRouteComponent(() => import("./plan-online-page"), "PlanOnlinePage"),
});
